export default __webpack_public_path__ + "static/media/error-call-to-attention-129258.0fc233ee.mp3";